module.exports = __webpack_public_path__ + "assets/images/06_active_21381889c21d3aa12d4a2674de5eb971.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatars/06_active.png
// module id = 171
// module chunks = 0